/**
 * Resolves once the launch screen has painted (its first contentful paint), so
 * the app's own code starts downloading after it rather than competing with
 * the stylesheet for the first frame on a slow phone network. Never waits long:
 * hidden tabs do not paint, and some browsers do not report paint timing.
 */
export function afterFirstPaint(maxWait = 150): Promise<void> {
  return new Promise((resolve) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      clearTimeout(timer);
      observer?.disconnect();
      resolve();
    };
    const timer = setTimeout(finish, maxWait);
    // Browsers without paint timing rely on the short wait above.
    const observer =
      document.visibilityState !== "hidden" &&
      typeof PerformanceObserver !== "undefined" &&
      PerformanceObserver.supportedEntryTypes?.includes("paint")
        ? new PerformanceObserver((list) => {
            if (
              list.getEntries().some((e) => e.name === "first-contentful-paint")
            )
              finish();
          })
        : undefined;
    if (document.visibilityState === "hidden") return finish();
    observer?.observe({ type: "paint", buffered: true });
  });
}
